import * as styles from './index.css';
import type { BoxProps } from '@customerio/pluma-components/react';
import { Box } from '@customerio/pluma-components/react';

/**
 * The colored dot representing a workspace. The color is configured by the user.
 */
export function WorkspaceDot({ color, className, style }: { color: string; className?: string } & BoxProps) {
  if (color == null) {
    return null;
  }

  return <Box className={[styles.workspaceColor, className]} style={[{ backgroundColor: color }, style]} />;
}
